import { render, staticRenderFns } from "./PointBlockingModal.vue?vue&type=template&id=345c12c9&scoped=true"
import script from "./PointBlockingModal.vue?vue&type=script&lang=js"
export * from "./PointBlockingModal.vue?vue&type=script&lang=js"
import style0 from "./PointBlockingModal.vue?vue&type=style&index=0&id=345c12c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c12c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345c12c9')) {
      api.createRecord('345c12c9', component.options)
    } else {
      api.reload('345c12c9', component.options)
    }
    module.hot.accept("./PointBlockingModal.vue?vue&type=template&id=345c12c9&scoped=true", function () {
      api.rerender('345c12c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/term/PointBlockingModal.vue"
export default component.exports